import { TitleColor } from '..';
import Text from '../Text';

const Education2021 = () => (
  <>
    <TitleColor text="Kurser 2021" smallTitle />
    <Text>
      <b>Practical Puppy Training Instructors Course</b>
      <br />
      Efteruddannelse hos Chirag Patel:
      <br />
      <i>
        "Learning how to help puppies develop socialisation skills and teach their caregivers how to
        do this. How to create a puppy-human relationship that is based on trust, confidence and
        empowerment. Focusing on teaching puppies behaviours that are useful for daily living and
        help prepare them to cope with life’s challenges."
      </i>
    </Text>
    <Text>
      <b>Karen Frost</b>
      <br />
      Kursusforløb februar - juli: Lydangst - sådan hjælper du din hund
    </Text>
  </>
);

export default Education2021;
